import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't reset scroll on navigation by default — that leaves
// users mid-page when they click into an integration / agent detail. This
// component sits inside <Routes> and forces scroll-to-top whenever the
// pathname changes.
export const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};
